import { writable, readable } from "svelte/store";
export const images = readable([
    {
        title: "Fairy in the Forest",
        img: "fairy-in-the-forest",
        alt: "A fairy in the forest",
        description: "It is a rainy day in the forest. There is a fairy sitting on a mushroom. There is a crow taking an egg from a bird. There is a squirrel climbing a tree. One of the birds is singing a song.",
        createdDate: new Date(2021, 4, 5),
    },
], () => { });
export const selectedImage = writable(null);
